import { render, staticRenderFns } from "./VIconButton.vue?vue&type=template&id=e7027292&"
import script from "./VIconButton.vue?vue&type=script&lang=ts&"
export * from "./VIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./VIconButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports